import { render, staticRenderFns } from "./SettingHome.vue?vue&type=template&id=74ebb3b5&scoped=true&"
import script from "./SettingHome.vue?vue&type=script&lang=js&"
export * from "./SettingHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ebb3b5",
  null
  
)

export default component.exports